import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UserProfileService } from '../../services/user-profile.service';
import { CountrySelectionService } from '../../services/country-selection.service';

@Component({
  selector: 'app-update-profile',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './update-profile.component.html',
  styleUrl: './update-profile.component.css'
})
export class UpdateProfileComponent implements OnInit {
  updateProfileForm: FormGroup;
  successMessage: string = '';
  countries: any[] = [];


  constructor(
    private fb: FormBuilder,
    private userProfileService: UserProfileService,
    private countrySelectionService: CountrySelectionService
  ) {
    this.updateProfileForm = this.fb.group({
      countryOffice: [null, Validators.required],
      'Current-User-Language': ['en', Validators.required]
    });
  }

  ngOnInit(): void {
    const savedProfile = this.userProfileService.getProfileData();
    if (savedProfile) {
      this.updateProfileForm.patchValue(savedProfile);
    }

    this.countries = this.countrySelectionService.getCountries();

    this.countrySelectionService.selectedCountry$.subscribe(country => {
      if (country) {
        this.updateProfileForm.patchValue({ countryOffice: country });
      }
    });
  }

  onSubmit() {
    if (this.updateProfileForm.valid) {
      this.userProfileService.saveProfileData(this.updateProfileForm.value);
      this.countrySelectionService.setSelectedCountry(this.updateProfileForm.value.countryOffice);
      this.successMessage = 'Profile data saved successfully';
      setTimeout(() => this.successMessage = '', 3000); // Hide message after 3 seconds
    }
  }

  onCountryChange() {
    if (this.updateProfileForm.valid) {
      this.userProfileService.saveProfileData(this.updateProfileForm.value);
      this.countrySelectionService.setSelectedCountry(this.updateProfileForm.value.countryOffice);
    }
  }
}